import { relayPagination } from '@urql/exchange-graphcache/extras';

const paginationConfig = relayPagination({
  mergeMode: 'inwards',
});
const messagesConfig = relayPagination({
  mergeMode: 'outwards',
});

// Add Paginated Queries here
const resolvers = {
  Query: {
    latestMessagesByJobBasedOnUser: paginationConfig,
    onsiteDeviceFieldsFragment: paginationConfig,
    paginatedAttendance: paginationConfig,
    paginatedTransactions: paginationConfig,
    paginatedWorkersByStatus: paginationConfig,
    paginatedJobRequests: paginationConfig,
    paginatedWorkers: paginationConfig,
    paginatedTeams: paginationConfig,
    paginatedVenues: paginationConfig,
    paginatedTransactionDetails: paginationConfig,
    paginatedCustomJobReports: paginationConfig,
    paginatedPositions: paginationConfig,
    activePinJobs: paginationConfig,
    messages: messagesConfig,
    importedDrafts: paginationConfig,
    shifts: paginationConfig,
    paginatedDraftJobRequests: paginationConfig,
    paginatedRequestors: paginationConfig,
    workerSchedulesByPeriod: paginationConfig,
    paginatedWonoloers: paginationConfig
  },
};

export default resolvers;
